__turbopack_context__.v({
  "className": "poppins_a899fb6e-module__iRNTfW__className",
  "variable": "poppins_a899fb6e-module__iRNTfW__variable",
});
